/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_UploadInputs */



/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Decks_UploadInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_upload = /** @type {((inputs?: Decks_UploadInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_UploadInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica")
	return /** @type {LocalizedString} */ ("Upload")
});